module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personZuzhi"
  }, [_c('el-card', {
    staticClass: "box-card fl"
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("组织机构")])]), _vm._v(" "), _c('el-aside', {
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "width": "300px"
    }
  }, [_c('el-tree', {
    ref: "eventCategoryTree",
    attrs: {
      "data": _vm.theData,
      "props": _vm.defaultProps,
      "node-key": "id",
      "highlight-current": "",
      "default-expand-all": "",
      "render-content": _vm.renderContent,
      "expand-on-click-node": false
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "add-event-dialog",
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.addEventdialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addEventdialogVisible = $event
      },
      "close": _vm.emptyDialog
    }
  }, [_c('el-form', {
    ref: "editStatus",
    attrs: {
      "model": _vm.editStatus,
      "label-position": _vm.labelPosition,
      "label-width": "120px",
      "rules": _vm.editEventNodeRules
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "上级组织名称",
      "prop": "deptName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": true
    },
    model: {
      value: (_vm.editStatus.deptName),
      callback: function($$v) {
        _vm.$set(_vm.editStatus, "deptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editStatus.deptName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addEventForm",
    staticClass: "clearfix",
    attrs: {
      "label-width": "80px",
      "model": _vm.addEventForm,
      "label-position": _vm.labelPosition,
      "rules": _vm.addEventNodeRules
    }
  }, [_c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "组织名称",
      "prop": "deptName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addEventForm.deptName),
      callback: function($$v) {
        _vm.$set(_vm.addEventForm, "deptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addEventForm.deptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "组织编码",
      "prop": "deptCode"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "50",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addEventForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.addEventForm, "deptCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addEventForm.deptCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "联系人",
      "prop": "deptLinkman"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "20",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addEventForm.deptLinkman),
      callback: function($$v) {
        _vm.$set(_vm.addEventForm, "deptLinkman", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addEventForm.deptLinkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "联系电话",
      "prop": "deptLinkmanPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addEventForm.deptLinkmanPhone),
      callback: function($$v) {
        _vm.$set(_vm.addEventForm, "deptLinkmanPhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addEventForm.deptLinkmanPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "电子邮件"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addEventForm.deptLinkmanEmail),
      callback: function($$v) {
        _vm.$set(_vm.addEventForm, "deptLinkmanEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addEventForm.deptLinkmanEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "备注",
      "prop": "memo"
    }
  }, [_c('el-input', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "clearable": "",
      "maxlength": "1000",
      "type": "textarea",
      "autosize": "",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addEventForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.addEventForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addEventForm.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('addEventForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('addEventForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.addEventFormCancleBtn()
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card box-card-big fr"
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header fl"
  }, [_vm._v("用户信息")]), _vm._v(" "), (_vm.personAuth.handleAddForm) ? _c('el-button', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddForm()
      }
    }
  }, [_vm._v("新增")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增用户信息",
      "visible": _vm.dialogAddFormVisible,
      "close-on-click-modal": false,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAddFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "watchEventForm",
    staticClass: "clearfix",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.watchEventForm,
      "rules": _vm.watchEventFormRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "部门:",
      "prop": "deptName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": true
    },
    model: {
      value: (_vm.watchEventForm.deptName),
      callback: function($$v) {
        _vm.$set(_vm.watchEventForm, "deptName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "watchEventForm.deptName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "姓名:",
      "prop": "staffName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "20",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.watchEventForm.staffName),
      callback: function($$v) {
        _vm.$set(_vm.watchEventForm, "staffName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "watchEventForm.staffName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addUserForm",
    staticClass: "clearfix",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addUserForm,
      "rules": _vm.addUserFormRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "登录名:",
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "密码:",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "password",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "确认密码:",
      "prop": "loginPassword2"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "password",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.loginPassword2),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "loginPassword2", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.loginPassword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "性别:",
      "prop": "staffSex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择员工性别"
    },
    model: {
      value: (_vm.addUserForm.staffSex),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffSex", $$v)
      },
      expression: "addUserForm.staffSex"
    }
  }, _vm._l((_vm.contractLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.product_type,
        "value": item.categorya_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "工号:",
      "prop": "jobNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "jobNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.jobNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "职务:",
      "prop": "staffDuty"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.staffDuty),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffDuty", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.staffDuty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "联系电话:"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "20",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.staffPhone),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffPhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.staffPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "电子邮箱:"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.staffEmail),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.staffEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "区域:",
      "prop": "region"
    }
  }, [_c('el-cascader', {
    ref: "regionAdd",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "options": _vm.regionData,
      "props": _vm.lazyRegin,
      "filterable": ""
    },
    model: {
      value: (_vm.addUserForm.region),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "region", $$v)
      },
      expression: "addUserForm.region"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "备注:",
      "prop": "momo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "textarea",
      "maxlength": "1000",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.momo),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "momo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.momo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.createData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogAddFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.configureInfo,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "deptId",
      "label": "部门",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staffName",
      "label": "姓名",
      "width": "150",
      "sortable": "",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loginName",
      "label": "账号",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), (_vm.personAuth.handleEditForm || _vm.personAuth.handleDel || _vm.personAuth.changePassword || _vm.personAuth.numberQuery) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("\n                                更多操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(_vm.personAuth.handleEditForm) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.handleEditForm(scope.$index, scope.row)
            }
          }
        }, [_vm._v("\n                                    修改用户\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.personAuth.handleDel) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除用户")]) : _vm._e(), _vm._v(" "), (_vm.personAuth.changePassword) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.changePassword(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重置密码")]) : _vm._e(), _vm._v(" "), (_vm.personAuth.numberQuery) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.numberQuery(scope.$index, scope.row)
            }
          }
        }, [_vm._v("账号授权")]) : _vm._e()], 1)], 1)]
      }
    }], null, false, 1031119734)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改用户信息",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticClass: "clearfix",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "部门:",
      "prop": "deptId"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "disabled": true
    },
    model: {
      value: (_vm.editForm.deptId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.deptId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "姓名:",
      "prop": "staffName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "type": "text",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.editForm.staffName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "staffName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editForm.staffName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addUserForm",
    staticClass: "clearfix",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addUserForm,
      "label-width": "100px",
      "rules": _vm.addUserFormRules
    }
  }, [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "登录名:",
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "工号:",
      "prop": "jobNo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "type": "text",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "jobNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.jobNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "职务:",
      "prop": "staffDuty"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "type": "text",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.staffDuty),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffDuty", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.staffDuty"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "联系电话:",
      "prop": "staffPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "20",
      "type": "text",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.staffPhone),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffPhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.staffPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "电子邮箱:",
      "prop": "staffEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "type": "text",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.staffEmail),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "staffEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.staffEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%",
      "margin-right": "15px"
    },
    attrs: {
      "label": "区域:",
      "prop": "region"
    }
  }, [_c('el-cascader', {
    ref: "regionUpdate",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "options": _vm.regionData,
      "props": _vm.lazyRegin,
      "filterable": ""
    },
    model: {
      value: (_vm.addUserForm.region),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "region", $$v)
      },
      expression: "addUserForm.region"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "备注:",
      "prop": "momo"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "1000",
      "type": "textarea",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.addUserForm.momo),
      callback: function($$v) {
        _vm.$set(_vm.addUserForm, "momo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addUserForm.momo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateData()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "账号权限",
      "visible": _vm.dislogNumberQuery,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogNumberQuery = $event
      }
    }
  }, [_c('el-form', {
    ref: "NumberQueryForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.NumberQueryForm,
      "label-width": "100px",
      "rules": _vm.NumberQueryFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "姓名:",
      "prop": "staffName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "disabled": true
    },
    model: {
      value: (_vm.NumberQueryForm.staffName),
      callback: function($$v) {
        _vm.$set(_vm.NumberQueryForm, "staffName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "NumberQueryForm.staffName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "登录名:",
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "30",
      "disabled": true
    },
    model: {
      value: (_vm.NumberQueryForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.NumberQueryForm, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "NumberQueryForm.loginName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "userRole",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.userRole,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.userRole.checked),
      callback: function($$v) {
        _vm.$set(_vm.userRole, "checked", $$v)
      },
      expression: "userRole.checked"
    }
  }, _vm._l((_vm.roleList), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "name": "userRole",
        "label": item.roleId,
        "value": item.roleId
      }
    }, [_vm._v(_vm._s(item.roleName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.numberQueryAgin()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dislogNumberQuery = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-10bef220","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/systemSet/personZuzhi.vue
// module id = 1590
// module chunks = 0